import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: spacing(0, 1),
    },
    small: {
        height: spacing(2),
        width: spacing(2),
        minHeight: spacing(2),
        minWidth: spacing(2),
    },
    medium: {
        height: spacing(4),
        width: spacing(4),
        minHeight: spacing(4),
        minWidth: spacing(4),
    },
    large: {
        height: spacing(8),
        width: spacing(8),
        minHeight: spacing(8),
        minWidth: spacing(8),
    },
    spinner: {
        stroke: 'currentColor',
        transform: 'translateZ(0)',
        animation: '$spinner-fade 400ms ease-in, $spinner-spin 1s infinite linear',
        animationFillMode: 'forwards',
        borderRadius: '50%',
        boxSizing: 'border-box',
        borderTop: ({ color }) => `3px solid ${color || palette.secondary.main}40`,
        borderRight: ({ color }) => `3px solid ${color || palette.secondary.main}40`,
        borderBottom: ({ color }) => `3px solid ${color || palette.secondary.main}40`,
        borderLeft: ({ color }) => `3px solid ${color || palette.secondary.main}`,
    },
    '@keyframes spinner-fade': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    '@keyframes spinner-spin': {
        from: { transform: 'rotate(0)' },
        to: { transform: 'rotate(360deg)' },
    },
}));
function LoadingSpinner({ className, size = 'medium', color, }) {
    const classes = useStyles({ color });
    return (React.createElement("div", { className: classNames(className, classes.root) },
        React.createElement("span", { className: classNames(classes.spinner, { [classes[size]]: size }) })));
}
export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map